import React from 'react';
import { StructuredData } from './StructuredData';
import ChannelContext from '../ChannelContext';
import { useShopConfig } from '../../hooks/useShopConfig';
function SiteLinksSearchStructuredData() {
    const { selectedChannel: { url } } = React.useContext(ChannelContext);
    const { routes } = useShopConfig();
    const action = {
        '@type': 'SearchAction',
        target: {
            '@type': 'EntryPoint',
            urlTemplate: `${url}${routes.search.path}?term={search_term_string}`
        },
        'query-input': 'required name=search_term_string'
    };
    const data = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: url,
        potentialAction: action
    };
    return React.createElement(StructuredData, { json: data });
}
export { SiteLinksSearchStructuredData };
//# sourceMappingURL=SiteLinksSearchStructuredData.js.map